import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { OrderingGameSelectorComponent } from './ordering-game-selector/ordering-game-selector.component';
import { ReactiveFormsModule } from '@angular/forms';
import { SharedModule } from 'src/app/shared/shared.module';
import { OrderingGameCoreService } from './ordering-game-core.service';

@NgModule({
  declarations: [OrderingGameSelectorComponent],
  imports: [CommonModule, ReactiveFormsModule, SharedModule],
  providers: [OrderingGameCoreService],
  exports: [OrderingGameSelectorComponent],
})
export class OrderingGameCoreModule {}
